export default "__VITE_ASSET__kF7$3UxR__"